import { Routes } from '@angular/router';
import { AuthGuard } from '../../../shared/authguards/auth.guard';
import { paidCustomerGuard } from '../../../shared/authguards/paid-customer.guard';
import { PaidActiveTimeGuard } from '../../../shared/authguards/paid-active-time-guard.service';
import { reviewDraftGuard } from '../../../shared/authguards/review-draft.guard';

export const PAID_CONSULTATION_ROUTES: Routes = [
  {
    path: "paid-consultation",
    loadComponent: () => import("./paid-consultation.component").then(m => m.PaidConsultationComponent),
    canActivate: [AuthGuard, paidCustomerGuard, PaidActiveTimeGuard],
    data: { title: "pageTitles.paidConsultation" },
    children: [
      {
        path: "",
        loadComponent: () => import("../../diseases/disease-form-wrapper/disease-form-wrapper.component").then(m => m.DiseaseFormWrapperComponent),
        data: { title: "pageTitles.paidConsultation" },
      },
      {
        path: "payment-instructions-info",
        loadComponent: () => import("./../payment-instructions-info/payment-instructions-info.component").then(m => m.PaymentInstructionsInfoComponent),
        data: { title: "pageTitles.paymentInstructionsInfo" },
      },
      {
        path: "feedback-info",
        loadComponent: () => import("./../feedback-info/feedback-info.component").then(m => m.FeedbackInfoComponent),
        data: { title: "pageTitles.feedbackInfo" },
      },
      {
        path: "info",
        loadComponent: () => import("../../diseases/disease-important-info/disease-important-info.component").then(m => m.DiseaseImportantInfoComponent),
        data: { title: "pageTitles.diseaseInfo" },
      },
      {
        path: "review",
        loadComponent: () => import("../../diseases/disease-review-wrapper/disease-review-wrapper.component").then(m => m.DiseaseReviewWrapperComponent),
        canActivate: [reviewDraftGuard],
        data: { title: "pageTitles.diseasesReview" },
      },
      {
        path: "message",
        loadComponent: () => import("../../message/message.component").then(m => m.MessageComponent),
        data: { title: "pageTitles.diseasesMessages" },
      },
    ],
  },
];
